import { render, staticRenderFns } from "./matriz-paso-a-paso.vue?vue&type=template&id=9cafe3ee"
import script from "./matriz-paso-a-paso.vue?vue&type=script&lang=js"
export * from "./matriz-paso-a-paso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports